import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgLanding = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#17181A"
    {...props}
  >
    <path d="M5.667 18h12.667m-7.874-6.275-2.582-.29s-.745 0-1.48-.861c-.734-.862-1.477-1.759-1.477-1.759s-.138-.22-.404-.151c-.267.069-.128.341-.128.341l.588 2.028s.066.51.548.764c.482.256 1.926.973 1.926.973s.992.481 2.495.638c1.503.156 6.828.778 6.828.778s2.03.296 2.15-.149c.12-.445-.761-.987-1.245-1.166-.483-.18-4.847-.822-4.847-.822l-2.434-3.722s-.35-.436-.33-.018c.02.417.493 4.148.493 4.148m-.105 1.831.202 1.601s.1.412.715-.27c.615-.68 1.089-1.18 1.089-1.18" />
  </svg>
);
const Memo = memo(SvgLanding);
export default Memo;
